import styled from "@emotion/styled";
import { PublicKey } from "@solana/web3.js";
import type { CurveType, LiquidityPools } from "@stepfinance/liquidity";
import type { FC, ReactNode } from "react";

import { ReactComponent as CopyIcon } from "../../assets/copy.svg";
import { notify } from "../../utils/notifications";
import { getTotalLiquidityInUSD } from "../../utils/pools/utils";
import { formatUSD, getCurveTypeName } from "../../utils/utils";
import { ExplorerLinkDisplay } from "../ExplorerLink/ExplorerLinkDisplay";
import { NumberLabel } from "../shared";

export type PoolDataProps = {
  // TODO narrow this type
  pool: LiquidityPools;
  initialRowValue: string;
  liquidityAValue: ReactNode;
  liquidityBValue: ReactNode;
  curveType: CurveType;
  hasUntrackableValue: boolean;
};

const onContractAddressCopied = (address: PublicKey) => () => {
  const rawAddress = address.toBase58();
  void navigator.clipboard.writeText(rawAddress);
  notify({
    message: "Address copied to clipboard",
    type: "success",
    description: rawAddress,
  });
};

export const PoolData: FC<PoolDataProps> = ({
  pool,
  initialRowValue,
  liquidityAValue,
  liquidityBValue,
  curveType,
  hasUntrackableValue,
}) => {
  return (
    <PoolDataColumn>
      <NumberLabel>{initialRowValue}</NumberLabel>
      {liquidityAValue}
      {liquidityBValue}
      <NumberLabel>
        {pool.supply && pool.supply > 0 && !hasUntrackableValue
          ? formatUSD.format(getTotalLiquidityInUSD(pool.liquidityInUSD) / pool.supply)
          : "-"}
      </NumberLabel>
      <span>
        <ExplorerLinkDisplay address={pool.mintAddress} type="address" addressLength={4} />
        <CopyIcon onClick={onContractAddressCopied(new PublicKey(pool.mintAddress))} />
      </span>
      <span>{getCurveTypeName(curveType)}</span>
    </PoolDataColumn>
  );
};

const PoolDataColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  text-align: right;

  span {
    font-size: 10px;
    line-height: 22px;
    font-weight: 700;
  }

  svg {
    margin-left: 5px;
    cursor: pointer;
  }
`;
